






















import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import ganiAsiaTenantCodes from "@/constants/ganiAsiaTenantCodes";

export default Vue.extend({
  data() {
    return {
      self: this,
      userManager,
      item: null,
      currentTab: "",
      tabs: null,
    };
  },
  methods: {
    makeTabs(item) {
      return {
        orders: {
          icon: "fas fa-shopping-cart",
          label: item.wholesale ? "đơn hàng thành công" : "Đơn hàng",
          condition() {
            return userManager.checkRole(["kt", "mkt", "tp", "rd", "rdl", "vdl", "vd", "telesale", "cdc", "qlk", "ksnb", "ksnbl", "design", "content", "k"]);
          },
        },
        statistics: {
          icon: "fas fa-chart-line",
          label: "Thống kê",
          condition() {
            return userManager.checkRole(["vd", "vdl"]) || !userManager.checkRole(["qlk"], true);
          },
        },
        product_combos: {
          icon: "fas fa-cubes",
          label: "Combo sản phẩm",
          condition() {
            return userManager.checkRole(["kt", "mkt", "tp", "rd", "rdl", "vdl", "vd"]);
          },
        },
        product_combo_discounts: {
          icon: "mdi-brightness-percent",
          label: "Chương trình khuyến mãi combo",
          condition({ item }) {
            return item && item.tmdt && (userManager.checkRole(["kt", "mkt", "tp"]) || (userManager.checkRole(["vdl"], true) && userManager.checkRole(["qlk"], true))) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        mkt_links: {
          icon: "mdi-link-variant",
          label: "MKT Link",
          condition() {
            return userManager.checkRole(["kt", "mkt", "tp", "rd", "rdl", "ksnb", "ksnbl"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        mkt_costs: {
          icon: "fas fa-money-check-alt",
          label: "Chi phí MKT",
          condition() {
            return userManager.checkRole(["kt", "mkt", "tp", "rd", "rdl", "ksnb", "ksnbl"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        creator_costs: {
          icon: "mdi-ballot-outline",
          label: "Chi phí KOC",
          condition({ item }) {
            return item?.tmdt && userManager.checkRole(["kt", "mkt", "tp", "rd", "rdl", "ksnb", "ksnbl"]);
          },
        },
        shops: {
          icon: "mdi-store",
          label: "Shop",
          condition({ item }) {
            return item && item.tmdt && userManager.checkRole(["kt", "mkt", "tp", "rd", "rdl", "ksnb", "ksnbl"]);
          },
        },
        creators: {
          icon: "mdi-creation",
          label: "KOC",
          condition({ item }) {
            return item?.tmdt && userManager.checkRole(["kt", "mkt", "tp"]);
          },
        },
        warehouse_exports: {
          icon: "fas fa-file-export",
          label: "Xuất kho",
          condition() {
            return userManager.checkRole(["kt", "qlk", "vd", "vdl"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        wholesale_customers: {
          icon: "mdi-face-agent",
          label: "Khách hàng sỉ",
          condition({ item }) {
            return item?.wholesale && userManager.checkRole(["kt", "vd", "vdl"]);
          },
        },
        wholesale_product_prices: {
          icon: "mdi-cash",
          label: "Giá bán sỉ",
          condition({ item }) {
            return item?.wholesale && userManager.checkRole(["kt", "vd", "vdl"]);
          },
        },
        wholesale_orders: {
          icon: "mdi-storefront-outline",
          label: "Đơn đặt hàng sỉ",
          condition({ item }) {
            return item?.wholesale && userManager.checkRole(["kt", "vd", "vdl"]);
          },
        },
        market_config_items: {
          icon: "mdi-cog-outline",
          label: "Cấu hình thị trường",
          condition() {
            return userManager.checkRole(["admin", "kt"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
      };
    },
  },
  async created() {
    this.item = await coreApiClient.call("markets", "findById", {
      id: this.$route.params.marketId,
    });
    this.tabs = this.makeTabs(this.item);
  },
});
